import { Component, OnInit } from "@angular/core";
import DaySeries from "@fullcalendar/core/common/DaySeries";
import { ConfirmationService } from "primeng/api";
import { ColorPicker } from "primeng/colorpicker";
import { UserService } from "../../../shared";
import { DistrictAdministrationService } from "../services/districtadministration.service";
import { DistrictDefaultPageRequest } from "./shared/DistrictDefaultPageRequest";
import { UpdateDistEmailRequest } from "./shared/UpdateDistEmailRequest";
import { DistrictUpdateNightlyAttendanceRequest } from "./shared/UpdateNightlyAttendanceRequest";
import { UpdatePhotoIDRequest } from "./shared/UpdatePhotoIDRequest";
import { UpdateVPPRequest } from "./shared/UpdateVPPREquest";
import { StringRequest } from "./shared/StringRequest";
import { PortalAppSettingsRequest } from "../services/portal-app-settings-request";
import * as moment from "moment";

@Component({
	selector: "app-districtsettings",
	templateUrl: "./districtsettings.component.html",
	styleUrls: ["./districtsettings.component.css"],
})
export class DistrictsettingsComponent implements OnInit {
	constructor(
		private userService: UserService,
		private districtadministrationService: DistrictAdministrationService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadDaysList();
		this.loadPhotoList();
		this.loadDefaultPage();
		this.loadPortalAppSettings();
	}

	///////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////
	user: any;

	ReportData = {
		NumDays: 0,
	};

	CAASSMobileSettingsData = {
		EnableOnRegServer: false,
		EnableMobileAccess: false,
		ServerName: "",
		ServerURL: "",
	};

	InfractionData = {
		MustAddAction: false,
	};

	ScanStationMustLogInData = {
		MustLogInAction: false,
	};

	CAASSMobileAppCountsData = {
		MobileApp: "",
		CurrentCount: 0,
		MaximumCount: 0,
	};

	DistrictEmailData = {
		DistrictDomain: "",
	};

	PhotoIDSettingsData = {
		DefaultNoPhoto: "",
	};

	SchoolEmailDomainsData = {
		SchoolDomainAllowed: true,
	};

	DefaultPageData = {
		SelectedDefaultPage: null,
		lstDefaultPages: [],
	};

	NightlyAttendanceData = {
		MarkIsCountPresentAsPresent: false,
	};

	PublicTransit = {
		TransitLabel: "Transit",
	};

	// Portal Apps
	HasParentPortalEnabled: boolean = false;
	ScheduleTime: Date = new Date();

	////////////////////
	// Lists/Dropdowns
	////////////////////

	NumDaysList: any = [];
	DefaultNoPhotoList: any = [];
	MobileAppList: any = [];

	PreferenceList: any = [];
	DomainEmailsList: any = [];

	///////////////////////////////////////////////

	PhotoLoading: boolean = false;
	PrefLoading: boolean = false;
	EmailLoading: boolean = false;
	DefaultPageLoading: boolean = false;
	PortalAppLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	///////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////
	loadDaysList() {
		this.NumDaysList = [];
		for (var i = 0; i <= 30; i++) {
			this.NumDaysList.push(i);
		}
		this.ReportData.NumDays = this.NumDaysList[0];
	}

	loadPhotoList() {
		this.PhotoLoading = true;

		var result = this.districtadministrationService.LoadDefaultImages("");
		result.subscribe(
			(response) => {
				this.PhotoLoading = false;

				this.DefaultNoPhotoList = response;

				this.PhotoIDSettingsData.DefaultNoPhoto = this.DefaultNoPhotoList[0].ImageLibraryID;
				this.loadDistrictPref(); ///
			},
			(error) => {
				this.PhotoLoading = false;
			}
		);
	}

	loadDistrictPref() {
		this.PrefLoading = true;

		var result = this.districtadministrationService.LoadDistrictPreferences("");
		result.subscribe(
			(response) => {
				this.PrefLoading = false;

				//Fill in fields w/ Data
				this.PreferenceList = response;

				//Reset values
				this.resetData();

				//Go through list of preferences - Set values if found
				this.updateData();

				this.loadEmailDomain();
			},
			(error) => {
				this.PrefLoading = false;
			}
		);
	}

	loadEmailDomain() {
		this.EmailLoading = true;

		var result = this.districtadministrationService.LoadDistrictEmail("");
		result.subscribe(
			(response) => {
				this.EmailLoading = false;

				this.DomainEmailsList = response;

				if (this.DomainEmailsList.length > 0) {
					this.DistrictEmailData.DistrictDomain = this.DomainEmailsList[0].EmailProviderEmailInfo;
				} else {
					this.DistrictEmailData.DistrictDomain = "";
				}
			},
			(error) => {
				this.EmailLoading = false;
			}
		);
	}

	loadDefaultPage() {
		this.DefaultPageLoading = true;

		var result = this.districtadministrationService.DefaultPageSelectList(this.user.userID);
		result.subscribe(
			(response: any) => {
				this.DefaultPageLoading = false;

				this.DefaultPageData.lstDefaultPages = response;

				this.DefaultPageData.SelectedDefaultPage = this.DefaultPageData.lstDefaultPages[0];

				for (var z = 0; z < this.DefaultPageData.lstDefaultPages.length; z++) {
					var next = this.DefaultPageData.lstDefaultPages[z];

					if (next.Selected == true) {
						this.DefaultPageData.SelectedDefaultPage = next;
						break;
					}
				}
			},
			(error) => {
				this.DefaultPageLoading = false;
			}
		);
	}

	loadPortalAppSettings() {
		this.PortalAppLoading = true;

		var result = this.districtadministrationService.DistrictPortalAppSettingsSelect();
		result.subscribe(
			(response: any) => {
				this.PortalAppLoading = false;

				this.HasParentPortalEnabled = response.HasParentPortalEnabled;
				this.ScheduleTime = new Date(response.ScheduleTime);
			},
			(error) => {
				this.PortalAppLoading = false;
			}
		);
	}

	resetData() {
		this.ReportData.NumDays = 0;

		this.CAASSMobileSettingsData.EnableOnRegServer = false;
		this.CAASSMobileSettingsData.EnableMobileAccess = false;
		this.CAASSMobileSettingsData.ServerName = "";
		this.CAASSMobileSettingsData.ServerURL = "";

		this.InfractionData.MustAddAction = false;
		this.ScanStationMustLogInData.MustLogInAction = false;

		this.CAASSMobileAppCountsData.MobileApp = "";
		this.CAASSMobileAppCountsData.CurrentCount = 0;
		this.CAASSMobileAppCountsData.MaximumCount = 0;

		this.DistrictEmailData.DistrictDomain = "";

		this.PhotoIDSettingsData.DefaultNoPhoto = "";

		this.SchoolEmailDomainsData.SchoolDomainAllowed = true;
	}

	updateData() {
		for (var i = 0; i < this.PreferenceList.length; i++) {
			var next = this.PreferenceList[i];

			//Report Settings
			if (next.Category == "GENERAL" && next.KeyName == "ReportPurgeDays") {
				this.ReportData.NumDays = Number(next.KeyValue);
			}

			//Infraction Settings
			else if (next.Category == "General" && next.KeyName == "MustAddActionFromPrimary") {
				this.InfractionData.MustAddAction = next.KeyValue;
			}

			//StationLogInRequired
			else if (next.Category == "SCANSTATION" && next.KeyName == "StationLogInRequiredDistrict") {
				this.ScanStationMustLogInData.MustLogInAction = next.KeyValue == "1" ? true : false;
			}

			//District Email

			//Photo ID
			else if (next.Category == "GENERAL" && next.KeyName == "DefaultNoPhotoFound") {
				this.PhotoIDSettingsData.DefaultNoPhoto = next.KeyValue;
			}
			//School Domains
			else if (next.Category == "General" && next.KeyName == "SchoolDomainsAllowed") {
				this.SchoolEmailDomainsData.SchoolDomainAllowed = next.KeyValue == "True" ? true : false;
			} else if (next.Category == "LateNightUpdateAttendance" && next.KeyName == "MarkIsCountPresentAsPresent") {
				this.NightlyAttendanceData.MarkIsCountPresentAsPresent = next.KeyValue == "1" ? true : false;
			} else if (next.Category == "GENERAL" && next.KeyName == "PublicTransitLabel") {
				this.PublicTransit.TransitLabel = next.KeyValue;
			}
		}
	}

	///////////////////////////////////////////////

	///////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////

	UpdateReportSettings() {
		//Call SP
		var result = this.districtadministrationService.UpdateReportSettings("", this.ReportData.NumDays);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Report Settings were Successfully Updated",
						header: "Report Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Report Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	UpdateInfractionSettings() {
		//Call SP
		var result = this.districtadministrationService.UpdateInfractionSettings("", this.InfractionData.MustAddAction == true ? 1 : 0);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Infraction Settings were Successfully Updated",
						header: "Infraction Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Infraction Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	UpdateScanStationMustLogInSetting() {
		//Call SP
		var result = this.districtadministrationService.UpdateScanStationMustLogInSetting("", this.ScanStationMustLogInData.MustLogInAction == true ? 1 : 0);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "ScanStation LogIn Required Setting was Successfully Updated",
						header: "ScanStation LogIn Required Setting",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update ScanStation LogIn Required Setting",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	UpdateDistrictEmailSettings() {
		//Check email format
		if (
			!(this.DistrictEmailData.DistrictDomain.substr(this.DistrictEmailData.DistrictDomain.length - 4, 4) == ".org") &&
			!(this.DistrictEmailData.DistrictDomain.substr(this.DistrictEmailData.DistrictDomain.length - 4, 4) == ".com") &&
			!(this.DistrictEmailData.DistrictDomain.substr(this.DistrictEmailData.DistrictDomain.length - 3, 3) == ".us")
		) {
			this.confirmationService.confirm({
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: "Domain is not a .com, .org or .us address. Do you want to add it anyways?",
				header: "WARNING",
				icon: "fa",
				accept: () => {
					//Ask if user wants to delete old email addresses
					this.UpdateEmailDomain();
					return;
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.UpdateEmailDomain();
			return;
		}
	}

	UpdateEmailDomain() {
		let parms: UpdateDistEmailRequest = {
			ApplicationID: "",
			EmailDomain: this.DistrictEmailData.DistrictDomain,
		};

		//Call SP
		var result = this.districtadministrationService.UpdateDistrictDomain(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "District Email Domain was Successfully Updated",
						header: "District Email Domain",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update District Email Domain",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	UpdatePhotoIDSettings() {
		let parms: UpdatePhotoIDRequest = {
			ApplicationID: "",
			PhotoLibraryID: this.PhotoIDSettingsData.DefaultNoPhoto,
		};

		//Call SP
		var result = this.districtadministrationService.UpdatePhotoIDSettings(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Photo ID Settings were Successfully Updated",
						header: "Photo ID Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Photo ID Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	UpdateSchoolEmailDomains() {
		//Call SP
		var result = this.districtadministrationService.UpdateSchoolDomainSettings("", this.SchoolEmailDomainsData.SchoolDomainAllowed == true ? 1 : 0);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Email Domain Settings were Successfully Updated",
						header: "School Email Domain Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update School Email Domain Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	DistrictUpdateDefaultPage() {
		if (this.DefaultPageData.SelectedDefaultPage == null) {
			return;
		}

		let parms: DistrictDefaultPageRequest = {
			ApplicationItemID: this.DefaultPageData.SelectedDefaultPage.ID,
		};

		//Call SP
		var result = this.districtadministrationService.DistrictUpdateDefaultPage(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Default Page Settings were Successfully Updated. If a user does not have their default page set, they will be redirected to the district page when they log in. Users can set their default page in My Settings (gear icon next to the log out button)",
						header: "Default Page Settings",
						icon: "fa",
						accept: () => {
							this.loadDefaultPage();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Default Page Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	DistrictResetDefaultPage() {
		//Call SP
		var result = this.districtadministrationService.DistrictResetDefaultPage();
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Default Page Settings were Successfully Reset. When users log in they will be redirected to the default dashboard or their preferred page if they set one in my settings (Gear icon next to the log out button)",
						header: "Default Page Settings",
						icon: "fa",
						accept: () => {
							this.loadDefaultPage();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Reset Default Page Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	DistrictUpdateNightlyAttendance() {
		var parms: DistrictUpdateNightlyAttendanceRequest = {
			MarkIsCountPresentAsPresent: this.NightlyAttendanceData.MarkIsCountPresentAsPresent == true ? 1 : 0,
		};

		//Call SP
		var result = this.districtadministrationService.DistrictUpdateNightlyAttendance(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Nightly Attendance Settings were Successfully Updated. This will go into effect tonight when the attendance job runs and students are automatically marked as absent or present.",
						header: "Nightly Attendance Settings",
						icon: "fa",
						accept: () => {
							this.loadDefaultPage();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Nightly Attendance Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	DistrictUpdatePublicTransit() {
		var parms: StringRequest = {
			str: this.PublicTransit.TransitLabel,
		};

		//Call SP
		var result = this.districtadministrationService.PublicTransitLabelUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Public Transit Settings were Successfully Updated.",
						header: "Public Transit Settings",
						icon: "fa",
						accept: () => {
							this.loadDefaultPage();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Public Transit Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	DistrictUpdatePortalApps() {
		this.confirmationService.confirm({
			acceptLabel: "Yes, Update All Schools",
			rejectLabel: "No, Cancel",
			rejectVisible: true,
			message:
				"Changing the Absent Notification Time for the district will OVERRIDE ALL SCHOOLS. Some schools send notifications earlier or later than the district time. They will get overriden with the district's time. Are you sure you want to continue?",
			header: "Confirm Portal App Settings",
			icon: "fa",
			accept: () => {
				this.FinishDistrictUpdatePortalApps();
			},
		});
	}

	FinishDistrictUpdatePortalApps() {
		var fsDate = moment(this.ScheduleTime).format("HH:mm:ss");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Schedule Time";
			return;
		}

		var parms: PortalAppSettingsRequest = {
			ScheduleTime: fsDate,
			UpdateEarlier: true,
			UpdateLater: true,
		};

		//Call SP
		var result = this.districtadministrationService.DistrictPortalAppSettingsUpdate(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Portal App Settings were Successfully Updated.",
						header: "Portal App Settings",
						icon: "fa",
						accept: () => {
							this.loadPortalAppSettings();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Portal App Settings: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////

	///////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////

	HexRGBAToRGB(val) {
		var colorVal = String(val);

		//Remove first 2 values that specify transparency
		colorVal = colorVal.substring(0, 1) + colorVal.substring(3, colorVal.length);

		return colorVal;
	}

	HexRGBToRGBA(val) {
		var colorVal = String(val);

		//Remove #
		colorVal = colorVal.substring(1, colorVal.length);

		//Add FF for full opacity
		while (colorVal.length < 6) {
			colorVal = "0" + colorVal;
		}
		colorVal = "FF" + colorVal;

		return colorVal;
	}

	IsLoading() {
		return (
			this.PhotoLoading == true ||
			this.PrefLoading == true ||
			this.EmailLoading == true ||
			this.DefaultPageLoading == true ||
			this.PortalAppLoading == true ||
			this.Processing == true
		);
	}

	///////////////////////////////////////////////
}
